import globalConfig from '@utiles/officialStore/globalConfig';
import { getJSONWithoutEntryParam } from './ultile';

// 获取活动请求地址
const getActivityUrl = (action, name = '') => {
  return `//gactivityapi.${globalConfig.getMainHost()}/activity/execute?name=${name}&action=${action}`;
};

export const SET_SERVER_HISTORY_LIST = 'SET_SERVER_HISTORY_LIST';
export const SET_SERVER_LIST = 'SET_SERVER_LIST';
export const SET_ROLE_LIST = 'SET_ROLE_LIST';

export const GET_AWARD_BASIC = 'GET_AWARD_BASIC';
export const GET_AWARD_SERVER_LIST = 'GET_AWARD_SERVER_LIST';
export const GET_AWARD_ROLE_LITS = 'GET_AWARD_ROLE_LITS';
export const GET_AWARD_BIND_ROLE = 'GET_AWARD_BIND_ROLE';
export const GET_AWARD_GIFT = 'GET_AWARD_GIFT';

export default {
  state: {
    awardServerHistoryList: [],
    awardServerList: [],
    awardRoleList: []
  },
  mutations: {
    [SET_SERVER_HISTORY_LIST](state, list) {
      state.awardServerHistoryList = list || [];
    },
    [SET_SERVER_LIST](state, list) {
      state.awardServerList = list || [];
    },
    [SET_ROLE_LIST](state, list) {
      state.awardRoleList = list || [];
    }
  },
  actions: {
    // 获取基础信息
    [GET_AWARD_BASIC]({ rootState, getters }) {
      return getJSONWithoutEntryParam(
        getActivityUrl('basic', rootState.page.pwaActivityName),
        {
          languages: rootState.lang
        }
      ).then(({ res }) => {
        return res;
      });
    },
    // 获取服务器列表
    [GET_AWARD_SERVER_LIST]({ commit, rootState, getters }) {
      return getJSONWithoutEntryParam(
        getActivityUrl('listServerNew', rootState.page.pwaActivityName),
        {
          languages: rootState.lang
        }
      ).then(({ res }) => {
        commit(SET_ROLE_LIST, []);
        if (+res?.result === 1) {
          commit(SET_SERVER_HISTORY_LIST, res?.data?.recent_servers);
          commit(SET_SERVER_LIST, res?.data?.all_servers);
        } else {
          commit(SET_SERVER_HISTORY_LIST, []);
          commit(SET_SERVER_LIST, []);
        }
        return res;
      });
    },
    // 获取角色
    [GET_AWARD_ROLE_LITS]({ commit, rootState, getters }, params = {}) {
      return getJSONWithoutEntryParam(
        getActivityUrl('getMobileGameRole', rootState.page.pwaActivityName),
        {
          params: JSON.stringify(
            Object.assign(
              {},
              {
                languages: rootState.lang
              },
              params
            )
          )
        }
      ).then(({ res }) => {
        if (+res?.result === 1) {
          commit(SET_ROLE_LIST, res?.data || []);
        } else {
          commit(SET_ROLE_LIST, []);
        }
        return res;
      });
    },
    // 绑定角色
    [GET_AWARD_BIND_ROLE]({ rootState, getters }, params = {}) {
      return getJSONWithoutEntryParam(
        getActivityUrl('bindRole', rootState.page.pwaActivityName),
        {
          params: JSON.stringify(
            Object.assign(
              {},
              {
                languages: rootState.lang
              },
              params
            )
          )
        }
      ).then(({ res }) => {
        return res;
      });
    },
    // 领取奖励
    [GET_AWARD_GIFT]({ rootState, getters }, params = {}) {
      return getJSONWithoutEntryParam(
        getActivityUrl('award', rootState.page.pwaActivityName),
        {
          params: JSON.stringify(
            Object.assign(
              {},
              {
                languages: rootState.lang
              },
              params
            )
          )
        }
      ).then(({ res }) => {
        return res;
      });
    }
  }
};
